// Route for the standalone "update billing info" page we email to customers.
// Security comes from the existing email + OTP login and a Salesforce Contact
// lookup — there is no token/secret in the URL itself.
export const UPDATE_CUSTOMER_ORDERS_PATH = '/update-customer-orders';

// `app` context passed to custom/getInitialDetails. A non-blank `app` makes the
// Salesforce PortalAPIHandler route to the ungated getInitialDetails overload
// (see PortalAPIService.getInitialDetails(email, payload, app)), which lets a
// Contact that exists in Salesforce log in even when it is NOT Portal-Enabled.
// Such contacts are then confined to UPDATE_CUSTOMER_ORDERS_PATH (see MainLayout).
export const ORDER_UPDATE_APP = 'order-update';
